<template>
    <v-row no-gutters class="fill-height">
        <v-col class="employment-form-form__side" cols="12" xl="" v-if="!mobile">
            <form-side v-model="form" @input="emit" />
        </v-col>
        <v-col cols="auto" v-if="!mobile"> <v-divider vertical /> </v-col>
        <v-col class="employment-form-form__body" cols="12" xl="" style="position: relative" :key="key">
            <form-body v-model="form" @input="emit" />
            <form-tool v-if="mobile" v-model="form" @input="emit" />
            <form-edit v-if="mobile" />
            <form-list v-if="mobile" v-model="form" @input="emit" />
        </v-col>
        <v-col cols="auto" v-if="!mobile"> <v-divider vertical /> </v-col>

        <v-col class="employment-form-form__desc" cols="12" xl="" v-if="!mobile">
            <form-desc v-model="form" @input="emit" />
        </v-col>
        <form-init v-model="form" @input="emit" />
    </v-row>
</template>

<script>
import { initEmploymentForm } from "@/assets/variables";
import { mapState } from "vuex";

import FormBody from "./form-body.vue";
import FormDesc from "./form-desc.vue";
import FormEdit from "./form-edit.vue";
import FormInit from "./form-init.vue";
import FormList from "./form-list.vue";
import FormSide from "./form-side.vue";
import FormTool from "./form-tool.vue";

export default {
    components: {
        FormBody,
        FormDesc,
        FormEdit,
        FormInit,
        FormList,
        FormSide,
        FormTool,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentForm>} */
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        shows: false,
        form: initEmploymentForm(),
    }),
    computed: {
        ...mapState("employment/form/page", ["key"]),
        ...mapState("ui", { mobile: (store) => store.window.innerWidth < 1600 }),
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", initEmploymentForm(this.form));
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
};
</script>

<style lang="scss" scoped>
.employment-form-form {
    &__side,
    &__desc,
    &__body {
        height: 100%;
    }

    &__body {
        max-width: 100vw;
    }
}
@media (min-width: 1600px) {
    .employment-form-form {
        &__side,
        &__desc,
        &__body {
            height: 100%;
        }
        &__side,
        &__desc {
            min-width: 320px;
            max-width: 320px;
        }
        &__body {
            max-width: calc(100vw - 320px - 1px - 1px - 320px);
        }
    }
}
</style>
